import { useEffect, useState } from "react";
import { FormValues, SettlementsTableData, TotalsData } from "./types";
import { Container } from "./styles";
import LoadingOverlay from "../../../components/LoadingOverlay";
import { T2 } from "../../../styles/titles";
import { FormFilter } from "./components/filter/filters";
import { Totals } from "./components/totals/totals";
import { LiveTable } from "./components/liveTable/liveTable";
import RecebiveisService from "./service/recebiveisService";
import { Button } from "../../terminaisPhoebus/styles";
import userGetMe from "../../../hooks/useCurrentUser";
import { can, PortalPermissions } from "../../../config/permissions";

const Recebiveis: React.FC = () => {
  const user = userGetMe();
  const recebiveisService = new RecebiveisService();
  const [isLoading, setIsLoading] = useState(false);
  const [tableData, setTableData] = useState<SettlementsTableData | null>(null);
  const [pageSize, setPageSize] = useState<number>(20);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [totals, setTotals] = useState<TotalsData | null>(null);
  const [filterData, setFilterData] = useState<any>(null);

  const fetchData = async () => {
    setIsLoading(true);

    try {
      const data = await recebiveisService.getRecebiveis(
        (currentPage - 1) * pageSize,
        pageSize,
        filterData
      );
      setTotals({
        totalValue: data.totalValue,
        totalLiquidValue: data.totalLiquidValue,
        totalMdrValue: data.totalMdrValue,
        totalPartnerMdrValue: data.totalPartnerMdrValue,
        totalAnticipation: data.totalAnticipation,
        totalPartnerAnticipation: data.totalPartnerAnticipation,
        totalCost: data.totalCost,
        totalPartnerCost: data.totalPartnerCost,
        totalAcquirer: data.totalAcquirer,
        totalRevenue: data.totalRevenue,
        totalPartnerRevenue: data.totalPartnerRevenue,
        takeRate: data.takeRate,
        totalRecords: data.count,
      });
      setTableData({
        records: data.records || [],
        count: data.count || 0,
      });
    } catch (error) {
      console.log("Erro ao buscar os detalhes da liquidação", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (filterData) {
      setCurrentPage(1);
    }
  }, [filterData]);

  useEffect(() => {
    if (filterData) {
      fetchData();
    }
  }, [filterData, currentPage, pageSize]);

  const handleDownload = async (filter?: FormValues) => {
    setIsLoading(true);
    const response = await recebiveisService.downloadRecebiveisXls(
      currentPage,
      pageSize,
      filter
    );

    if (response) {
      const objectUrl = window.URL.createObjectURL(response);
      const a = document.createElement("a");
      a.href = objectUrl;
      a.download = "Det Liq Recebiveis.xlsx"; // Nome do arquivo
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(objectUrl);
      document.body.removeChild(a);
    }
    setIsLoading(false);
  };

  return (
    <Container>
      <LoadingOverlay show={isLoading} relative />

      <T2>Detalhamento Liquidação - Recebimento</T2>
      {totals && <Totals data={totals} userType={user.userType} isAdmin={filterData.isAdmin}/>}
      <FormFilter getFilters={(data) => {setFilterData(data)}} userType={user.userType} />

      <div>
        {can(PortalPermissions.liquidacao.recebiveis.exportar) && (
          <Button
            onClick={() => {
              handleDownload(filterData);
            }}
            style={{
              marginBottom: "25px",
              marginRight: "24px",
              width: "150px",
              alignSelf: "start",
            }}
          >
            Download xlsx
          </Button>
        )}
      </div>

      {tableData && (
        <LiveTable
          data={tableData}
          currentPage={currentPage}
          pageSize={pageSize}
          onPageChange={setCurrentPage}
          onPageSizeChange={setPageSize}
          userType={user.userType}
          isAdmin={filterData.isAdmin}
        />
      )}
    </Container>
  );
};

export default Recebiveis;
